<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("tlt.pelletizing.selfTestPelletizing") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <!-- <li class="breadcrumb-item"><router-link to="/prd"><span>{{$t('tlt.pelletizing')}}</span></router-link></li> -->
          <li class="breadcrumb-item">
            <router-link to="/prd/selfTestPelletizing">
              <span>{{$t('tlt.pelletizing.selfTestPelletizing')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- <div class="col-lg-2">
        <div class="float-lg-right">
          <button class="btn btn-outline-primary" v-on:click="MMFNew('selfTestPelletizing')">
            <i class="fa fa-fw fa-lg fa-plus"></i>
            <span class="text">{{ $t("btn.basic.add") }}</span>
          </button>
        </div>
      </div> -->
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.selfTestPelletizing.testCode")}}</label>
                  <input class="form-control" type="text" v-model="testCodeFilter" />
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.selfTestPelletizing.startDate")}}</label>
                  <MmfDatepicker v-model="startDateFilter"></MmfDatepicker>
                </div>
                 <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.selfTestPelletizing.endDate")}}</label>
                  <MmfDatepicker v-model="endDateFilter"></MmfDatepicker>
                </div>
                   <div class="form-group col-md-2">
                                    <label class="control-label">{{$t('lbl.fm.locationName')}}：</label>
                                    <select class="form-control" v-model="locNameFilter">
                                        <option value="default">{{$t("lbl.basic.select.one")}}</option>
                                        <option value="球团车间一期">{{$t('lbl.basic.plant.pelletizing1')}}</option>
                                        <option value="球团车间二期">{{$t('lbl.basic.plant.pelletizing2')}}</option>
                                        <option value="球团车间三期">{{$t('lbl.basic.plant.pelletizing3')}}</option>
                                    </select>
                                </div>
                     <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.selfTestPelletizing.testShift")}}</label>
                   <select class="form-control" type="text" v-model="testShiftFilter">
                                            <option value = ''>{{ $t("lbl.basic.select.one") }}</option>
                                            <option value="甲">{{ $t("lbl.selfTestPelletizing.shiftA") }}</option>
                                            <option value="乙">{{ $t("lbl.selfTestPelletizing.shiftB") }}</option>  
                                            <option value="丙">{{ $t("lbl.selfTestPelletizing.shiftC") }}</option>  
                                        </select>
                </div>
                     <div class="form-group col-md-2">
                  <label class="control-label">{{$t("lbl.selfTestPelletizing.testMatName")}}</label>
                  <input class="form-control" type="text" v-model="testMatNameFilter" />
                </div>
                <div class="col-lg-12 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="MMFClearFilter('selfTestPelletizing')"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                    <button
                      class="btn btn-primary"
                      type="button"
                      v-on:click="MMFLoadRows('selfTestPelletizing')"
                    >
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{ $t("btn.basic.search") }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div id="qualityItemResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table
                entity="selfTestPelletizing"
                inline-actions-disabled
                :singleChoice="true"
                disableDelete
                disableEdit
              >
                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                  <button
                    :disabled="slotProps.checkedLength!=1"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                    v-on:click="PelletizingGri(entity)"
                  >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span class="text">{{ $t("tlt.pelletizing.selfTestPelletizingGri") }}</span>
                  </button>
                  <button
                    :disabled="slotProps.checkedLength!=1"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                    v-on:click="PelletizingPel(entity)"
                  >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span class="text">{{ $t("tlt.pelletizing.selfTestPelletizingPel") }}</span>
                  </button>
                  <button
                    :disabled="slotProps.checkedLength!=1"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                    v-on:click="PelletizingCal(entity)"
                  >
                    <i class="fa fa-cog" aria-hidden="true"></i>
                    <span class="text">{{ $t("tlt.pelletizing.selfTestPelletizingCal") }}</span>
                  </button>
                </div>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { filterFields } from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizing";
import { gridFields } from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizing";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "selfTestPelletizing/getField",
  mutationType: "selfTestPelletizing/updateField"
});

export default {
  name: "selfTestPelletizingList",
  data() {
    return {};
  },
  components: { MmfTable, MmfDatepicker },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(filterFields),

    ...mapState({
      rows: state => state.selfTestPelletizing.rows,
      tableColumns: gridFields,
      entity: state => state.selfTestPelletizing.entity
    })
  },
  methods: {
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter", "MMFNew"]),
    ...mapActions("selfTestPelletizing", [
      "PelletizingGri",
      "PelletizingPel",
      "PelletizingCal",
      "ReadSelfTestPelletizing"
    ])
  },
  created() {
    this.ReadSelfTestPelletizing();
  }
};
</script>
